import * as React from "react";
const SvgFiRrLampFloor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16.75 11a3.246 3.246 0 0 0 3.205-3.784l-.75-4.5A3.24 3.24 0 0 0 16 .001H8a3.24 3.24 0 0 0-3.206 2.715l-.75 4.5a3.24 3.24 0 0 0 .726 2.635A3.24 3.24 0 0 0 7.25 11H11v11H8a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2h-3V11h3.749M6.296 8.558a1.25 1.25 0 0 1-.279-1.014l.75-4.5A1.246 1.246 0 0 1 8.001 2h8c.613 0 1.132.439 1.232 1.044l.75 4.5A1.248 1.248 0 0 1 16.75 9h-9.5c-.368 0-.714-.161-.953-.442"
    />
  </svg>
);
export default SvgFiRrLampFloor;
